import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../../core/models';
import { BaseApiService } from '../../../../../core/services/base-api.service';
import {
  TrafficInquiryDTO,
  TrafficInquiryRequest,
  ValidateForwarderAssignmentRequestDTO,
} from '../../models/service-payment.model';
import { ServicePaymentRepository } from '../contracts/service-payment.repository';

@Injectable({
  providedIn: 'root',
})
export class ServicePaymentHttpRepository extends BaseApiService implements ServicePaymentRepository {
  private readonly controllerUrl = '/ServicePayment/';

  public list(
    request: TrafficInquiryRequest
  ): Observable<HttpResponse<ApiResponse<TrafficInquiryDTO>>> {
    return this.http.post<ApiResponse<TrafficInquiryDTO>>(
      `${this.baseUrl}${this.controllerUrl}list`,
      request,
      { observe: 'response' }
    );
  }

  /** POST validate-forwarder-assignment */
  public validateForwarderAssignment(
    request: ValidateForwarderAssignmentRequestDTO,
  ): Observable<HttpResponse<ApiResponse<boolean>>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.baseUrl}${this.controllerUrl}validate-forwarder-assignment`,
      request,
      { observe: 'response' },
    );
  }
}
